import { createReducer, on } from "@ngrx/store";
import { OfferSignatureRequested } from "../../models/offer-signature-requested";
import { loadSignatureRequestByIdAct, setViolationsSignatureRequestedAct, updateSignatureRequestedAct, updateSuccessSignatureRequestedAct } from "./signature-requested.actions";

const signatureRequested: OfferSignatureRequested = new OfferSignatureRequested();

export const signatureRequestedReducer = createReducer(
    {
        signatureRequested,
        violations: {},
        loading: true,
    },
    on(loadSignatureRequestByIdAct, (state, { signatureRequested }) => ({
        signatureRequested: { ...signatureRequested }, 
        violations: state.violations,
        loading: false,
    })),
    on(updateSignatureRequestedAct, (state, { signatureRequestedUpdated }) => ({
        signatureRequested: {... signatureRequestedUpdated},
        violations: {},
        loading: true
    })),
    on(updateSuccessSignatureRequestedAct, (state, { signatureRequestedUpdated }) => ({
        signatureRequested: {... signatureRequestedUpdated},
        violations: {},
        loading: false
    })),
    on(setViolationsSignatureRequestedAct, (state, { signatureRequestedForm, violations }) => ({
        signatureRequested: { ...signatureRequested },
        violations: {...violations},
        loading: state.loading
    }))
);